import styled from "styled-components";

const DivMain = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 430px;
  right: 30px;
  top: 20px;
  bottom: 20px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  padding: 5px 20px 16px 20px;
  overflow-y: auto;
  gap: 0px;

  .div-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    flex-shrink: 0;
    .btnClose {
      width: 30px;
      height: 30px;
      border-radius: 100%;
      padding: 0px;
    }
    .txt-title {
      font-size: 13px;
      font-weight: 700;
      font-family: "Roboto", Helvetica, sans-serif;
    }
  }

  .div-loading {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .div-error {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    .txt-error {
      font-size: 13px;
      color: #888;
      text-align: center;
      font-family: "Roboto";
    }
  }

  .div-section {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 14px;
    .txt-sectionTitle {
      font-size: 11px;
      font-weight: 700;
      color: #aaa;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      font-family: "Roboto";
      margin-bottom: 8px;
    }
  }

  .div-tripCard {
    background: #f6f8fa;
    border-radius: 10px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    .row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 8px;
      .lbl-key {
        font-size: 12px;
        font-weight: 600;
        color: #555;
        font-family: "Roboto";
        width: 90px;
        flex-shrink: 0;
      }
      .lbl-val {
        font-size: 12px;
        font-weight: 400;
        color: #222;
        font-family: "Roboto";
        flex: 1;
      }
      .tag-canceledBy {
        display: inline-flex;
        align-items: center;
        border-radius: 20px;
        padding: 2px 10px;
        font-size: 11px;
        font-weight: 700;
        font-family: "Roboto";
        &.driver {
          background: #fff3cd;
          color: #856404;
        }
        &.passenger {
          background: #d1ecf1;
          color: #0c5460;
        }
      }
      .tag-status {
        display: inline-flex;
        align-items: center;
        border-radius: 20px;
        padding: 2px 10px;
        font-size: 11px;
        font-weight: 700;
        font-family: "Roboto";
        &.tag-pending {
          background: #e5e7eb;
          color: #4b5563;
        }
        &.tag-compensated {
          background: #dbeafe;
          color: #1e40af;
        }
        &.tag-both {
          background: #f3e8ff;
          color: #6b21a8;
        }
      }
    }
  }

  .div-userCard {
    background: #f6f8fa;
    border-radius: 10px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    .div-userHeader {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      .txt-name {
        font-size: 13px;
        font-weight: 700;
        font-family: "Roboto";
        flex: 1;
      }
      .txt-tel {
        font-size: 12px;
        color: #777;
        font-family: "Roboto";
      }
    }
    .div-stats {
      display: flex;
      flex-direction: row;
      gap: 10px;
      flex-wrap: wrap;
      .stat-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
        border-radius: 8px;
        padding: 8px 12px;
        min-width: 70px;
        .stat-val {
          font-size: 18px;
          font-weight: 700;
          font-family: "Roboto";
          color: #222;
          line-height: 1.2;
        }
        .stat-lbl {
          font-size: 10px;
          color: #888;
          font-family: "Roboto";
          text-align: center;
          line-height: 1.3;
          margin-top: 2px;
        }
      }
    }
    .txt-lastTitle {
      font-size: 11px;
      font-weight: 600;
      color: #888;
      font-family: "Roboto";
      text-transform: uppercase;
      letter-spacing: 0.6px;
    }
    .div-lastMotives {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .motive-row {
        font-size: 12px;
        font-family: "Roboto";
        color: #444;
        padding: 3px 0;
        border-bottom: 1px solid #eee;
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .div-chart {
      width: 100%;
      height: 90px;
    }
    .div-blockBadge {
      display: flex;
      align-items: center;
      gap: 6px;
      background: #fff3cd;
      border-radius: 8px;
      padding: 6px 10px;
      .lbl-block {
        font-size: 12px;
        font-weight: 600;
        color: #856404;
        font-family: "Roboto";
        flex: 1;
      }
    }
    .div-compensateBadge {
      display: flex;
      align-items: center;
      gap: 6px;
      background: #d1e7dd;
      border-radius: 8px;
      padding: 6px 10px;
      .lbl-compensate {
        font-size: 12px;
        font-weight: 600;
        color: #0a3622;
        font-family: "Roboto";
        flex: 1;
      }
    }
  }

  .div-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 4px;
    .btn-action {
      width: 100%;
      padding: 11px 0;
      border-radius: 10px;
    }
  }
`;

const Styles = { DivMain };

export default Styles;
